import React, {Component} from "react";
import {Row, Col, Card, CardBody, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  getBookings,
  resetBookingQuery,
} from "../../store/booking/actions";
import {connect} from "react-redux";
import Paging from "../../components/Pagination/Pagination";
import {Space} from "antd";
import moment from "moment";
import Search from "../../components/Search/Search";
import BookingList from "../Bookings/List/BookingList";
import Refund from "../Bookings/Refund";
import ListSearch from "components/ListSearch/ListSearch";

class BookingsSubscription extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search: {text: '', filter: '', tagsFilters: {}},
      currentPage: 1,
      currentDate: moment(new Date()),
      filterModalOpen: false,
      refundModalOpen: false,
      refundBooking: {}
    }
    this.options = [
      {keySearch: 'parentID.name_parentID.surname', titleSearch: 'Име'},
      {keySearch: 'price', titleSearch: 'Цена'},
      {keySearch: 'professionalID.role', titleSearch: 'Роля на специалиста'},
      {keySearch: 'professionalID.name_professionalID.surname', titleSearch: 'Име на специалист'},
      {keySearch: 'time', titleSearch: 'Дата на часа'},

    ]
  }

  componentDidMount() {
    // Reset query to ensure clean state when switching between booking pages
    this.props.resetBookingQuery();
    this.props.getBookings({page: 1, bookingsType: 'subscription'});
  }
  onRefundOpen = (booking) => {
    this.setState({
      refundBooking: booking,
    });
  }
  setFilterModalOpen = (filterModalOpen) => {
    this.setState({filterModalOpen})
  }

  setRefundModalOpen = (refundModalOpen) => {
    this.setState({refundModalOpen})
  }
  refreshPage = () => {
    this.setState({search: {filter: '', text: '', tagsFilters: {}}})
    this.props.getBookings({page: 1, bookingsType: 'subscription'});
  }

  setPage = (currentPage) => {
    this.setState({currentPage})
    this.props.getBookings({page: currentPage, bookingsType: 'subscription'});
  }

  onSubmit = (e, search) => {
    e.preventDefault()
    if ((search.text && search.filter) || Object.keys(search.tagsFilters).length) {
      this.props.getBookings({search, page: 1, bookingsType: 'subscription'});
    } else {
      this.props.getBookings({page: 1, bookingsType: 'subscription'});
    }
    this.setState({currentPage: 1, search, filterModalOpen: false})
  }

  handleTextSearch = (q) => {
    this.setState({currentPage: 1})
    this.props.getBookings({page: 1, bookingsType: 'subscription', q, search: this.state.search});
  }

  render() {
    const {search, currentPage, filterModalOpen, refundModalOpen, refundBooking} = this.state
    const {bookingList, query} = this.props;
    const q = query?.q;
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Резервации" breadcrumbItem="Резервации"/>

            <Row>
              <Col>
                <Card>
                  <div className="list-toolbar py-2">
                    <Paging setPage={this.setPage} currentPage={currentPage} pages={bookingList?.pages}/>
                    <ListSearch
                      value={q || ""}
                      onSearch={this.handleTextSearch}
                      placeholder="Търсене по стопанин, специалист или любимец"
                    />
                    <Space direction="horizontal" className="mr-4">
                      <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                              onClick={() => this.setFilterModalOpen(!filterModalOpen)}><i
                        className="bx bx-filter-alt align-middle"></i></Button>
                      {(search.text || Object.keys(search.tagsFilters).length > 0) &&
                        <Button type={'button'} className='btn btn-dark waves-effect waves-light search-btn'
                                onClick={this.refreshPage}><i
                          className='bx bx-revision align-middle'></i></Button>}
                    </Space>
                  </div>
                  <CardBody>
                    <BookingList
                      list={bookingList?.bookings}
                      onRemoveItem={this.onRemove}
                      onEditItem={this.onEdit}
                      history={this.props.history}
                      onRefundOpen={this.onRefundOpen}
                      setRefundModalOpen={this.setRefundModalOpen}
                    />
                  </CardBody>
                  <Paging setPage={this.setPage} currentPage={this.state.currentPage} pages={bookingList?.pages}/>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <Search searchModalOpen={filterModalOpen}
                options={this.options}
                filterData={['time']}
                searchVar={search}
                tags={bookingList?.tags}
                onSubmit={this.onSubmit}
                onCancel={() => this.setFilterModalOpen(false)}/>
        {refundModalOpen && <Refund isNewBookingModalOpen={refundModalOpen}
                                    data={refundBooking?.refund}
                                    onCancel={() => this.setRefundModalOpen(false)}
                                    isLoading={refundBooking?.refund.length}
                                    handleChange={this.handleChange} />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {Booking} = state;
  return {...Booking};
};

export default connect(mapStateToProps, {
  getBookings,
  resetBookingQuery,
})(BookingsSubscription);
